<template>
    <div>
        <el-tabs v-model="activeName">
            <el-tab-pane :label="$t('vendors_tab_accountTHINK_invoices')" name="vendorInvoices">
            </el-tab-pane>
            <el-tab-pane :label="$t('vendors_tab_accountTHINK_payments')" name="vendorPayments">
            </el-tab-pane>
            <el-tab-pane :label="$t('vendors_tab_accountTHINK_credit_notes')" name="vendorCreditNotes">
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
  export default {
    name: 'AccountThinkTab',
    components: {

    },
    created(){

    },
    computed:{

    },
    data(){
      return{
        activeName: 'vendorInvoices'
      }
    }
  }
</script>

<style lang="less" scoped>

</style>
